import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from "react";
interface ClockIconProps {
  readonly className?: string;
}

/**
 * Clock icon for the Coming Soon button
 */
export default function ClockIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}